import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import './PlanningPastOverlay.scss'

export default class PlanningPastOverlay extends PureComponent {
  static propTypes = {
    startTime: PropTypes.object.isRequired,
    timeToScreen: PropTypes.func.isRequired
  }

  render() {
    // If start of visible timeframe lies in the future -> don't render the overlay at all
    if (this.props.startTime >= moment().valueOf()) {
      return null
    }

    const overlayTopPos = this.props.timeToScreen(this.props.startTime)
    const overlayBottomPos = this.props.timeToScreen(moment().valueOf())
    const overlayHeight = overlayBottomPos - overlayTopPos

    const overlayStyle = {
      height: overlayHeight
    }

    return (
      <div className="past-overlay-wrapper" style={overlayStyle}>
        <div className="past-overlay" />
        <div className="past-present-separator" />
      </div>
    )
  }
}
